// extracted by mini-css-extract-plugin
module.exports = {"body":"_3kp7q"};